import React from 'react'
import styled from 'styled-components'
import {BlockBase} from 'Event/Marketplace/Block/base'
import {useConfigPage} from 'organization/Marketplace/config/ConfigPageProvider'
import Row, {RowBlock} from 'Event/Marketplace/Block/RowBlock'
import {BlockComponentProps} from 'Event/Marketplace/Block'
import {ConfigurableBlockTargetProps} from 'organization/Marketplace/config/NLConfigurableBlock'
import {ConfigurableSectionContext} from 'organization/Marketplace/config/ConfigurableSection'
import NLConfigurableColumn from 'organization/Marketplace/config/NLConfigurableColumn'

export const movedBlockBetweenSectionEvent = 'block_moved_between_section'

type ConfigurableRowProps = RowBlock &
  BlockComponentProps &
  ConfigurableBlockTargetProps

export default function ConfigurableRow(props: ConfigurableRowProps) {
  const {
    id: sectionId,
    template,
    blocks,
    visibility,
    onSave,
    numColumns,
    getPreviewData,
    blockPath,
    availableBlocks,
  } = props
  const {isMobileMode} = useConfigPage()

  return (
    <ConfigurableSectionContext.Provider
      value={{
        update: onSave,
        sectionId,
      }}
    >
      <Box isMobileMode={isMobileMode} visibility={visibility}>
        <Row {...props} template={template}>
          {Array.from({length: numColumns}, (_, i) => (
            <NLConfigurableColumn
              id={sectionId}
              key={i}
              number={i + 1}
              block={props}
              blocks={blocks}
              template={template}
              availableBlocks={availableBlocks}
              onSave={onSave}
              blockPath={blockPath}
              getPreviewData={getPreviewData}
            />
          ))}
        </Row>
      </Box>
    </ConfigurableSectionContext.Provider>
  )
}

const Box = styled.div<{
  visibility: BlockBase['visibility']
  isMobileMode: boolean
}>`
  width: 100%;
  padding: 2px;

  display: ${(props) =>
    props.visibility === 'desktop_only' ? 'none' : 'block'};
  @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
    display: ${(props) =>
      (props.visibility === 'mobile_only' && !props.isMobileMode) ||
      (props.visibility === 'desktop_only' && props.isMobileMode)
        ? 'none'
        : 'block'};
  }
`
